import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  section: {
    marginLeft: 20,
    marginBottom: 10,
    [breakpoints.down(769)]: {
      margin: '10px 20px 10px 0',
      '&:first-child': {
        marginTop: 20,
      },
    },
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
    fontSize: 14,
  },
  tooltip: {
    marginLeft: 5,
  },
}));
